import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvService } from 'environments/env.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BaseurlHttpInterceptor implements HttpInterceptor {
  constructor(private readonly _envService: EnvService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.startsWith('http') || request.url.startsWith('assets')) {
      return next.handle(request);
    }

    const destinationUrl = this._envService.getProxiedUrl(request.url);

    // BUILD REQUEST
    request = request.clone({
      url: destinationUrl,
    });

    const token = document.cookie
      .split('; ')
      .find((row) => row.startsWith('XSRF-TOKEN='))
      ?.split('=')[1];

    if (token) {
      request = request.clone({
        setHeaders: {
          'X-XSRF-TOKEN': decodeURIComponent(token),
        },
      });
    }

    return next.handle(request);
  }
}
